import { HlmButton } from './lib/hlm-button';

export * from './lib/hlm-button';
export * from './lib/hlm-button.token';

export const HlmButtonImports = [HlmButton] as const;
